export type FilterType = 'byStatus' | 'byPinned' | 'byClient';
export type StatusFilter = 'all' | 'inprogress' | 'completed' | 'rejected';

export type FilterState = Readonly<{
  type: FilterType;
  quickSearchTerm?: string;
  status: StatusFilter;
  client?: string;
  product?: string;
  pinnedGroup?: string;
}>;

export function initialFilterState(): FilterState {
  return {
    type: 'byStatus',
    status: 'all',
  };
}
